import React from 'react';
import { FaPencilAlt } from 'react-icons/fa';
import TableActionButton from '../TableActionButton/TableActionButton';

const TableActionButtonEdit = ({ title = 'Editar', size = 10, onClick = () => {}, style, className }) => {
  return <TableActionButton onClick={onClick} title={title} icon={<FaPencilAlt size={size} className={className} />} style={style} />;
};

export default TableActionButtonEdit;
